module.exports = __webpack_public_path__ + "static/badge-b68b3fe866e3ac2f0ed99d3d98b47470.png";